'use strict'

import master from 'Modules/master'
import rollingTexts from 'Modules/rollingTexts'

// TODO
// Refacto dans layout
master.process()
rollingTexts.init()
